module.exports = __webpack_public_path__ + "static/media/10gb.727c1cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/10gb.png
// module id = 76
// module chunks = 0